export interface TopicChild    { value: string; label: string; }
export interface TopicSubGroup { value: string; label: string; children: TopicChild[]; }
export interface TopicGroup    { label: string; subGroups: TopicSubGroup[]; }

export const TOPIC_GROUPS: TopicGroup[] = [
  {
    label: 'Health',
    subGroups: [
      { value: '33', label: 'Pandemics', children: [
        { value: '58', label: 'COVID-19 vaccines: Needle-free and needle based-injection systems for medical use' },
        { value: '59', label: 'COVID-19 vaccines: Aseptic processing' },
        { value: '60', label: 'Medicine production' },
        { value: '61', label: 'Respiratory equipment' },
        { value: '62', label: 'Pandemic preparedness and resilience' },
        { value: '63', label: 'Tests and measurement methods for SARS/COV19: Pathogens' },
        { value: '64', label: 'Tests and measurement methods for SARS/COV19: Wastewater' },
        { value: '65', label: 'Epidemiology: Risk, population, genetic' },
      ]},
      { value: '34', label: 'E-Health and personalised services', children: [
        { value: '123', label: 'Accessibility' },
        { value: '122', label: 'Assisted living' },
        { value: '125', label: 'Cybersecurity in healthcare' },
        { value: '121', label: 'Digital healthcare' },
        { value: '119', label: 'eHealth' },
        { value: '120', label: 'Mobile applications' },
        { value: '124', label: 'Personal medicine' },
      ]},
      { value: '35', label: 'Design and use of medical device', children: [
        { value: '128', label: '5G for live consultations and remote surgery' },
        { value: '129', label: 'Biotechnology (organ-on-chip)' },
        { value: '126', label: 'Design for disassembly' },
        { value: '130', label: 'Patient safety' },
        { value: '127', label: 'Reliability of medical devices (for emergency use)' },
      ]},
      { value: '36', label: 'AI in Healthcare', children: [
        { value: '132', label: 'AI health services' },
        { value: '131', label: 'AI in radiology' },
        { value: '133', label: 'Synthetic data' },
      ]},
    ]
  },
  {
    label: 'Resilience',
    subGroups: [
      { value: '38', label: 'Robust supply chains', children: [
        { value: '138', label: 'Business continuity' },
        { value: '134', label: 'Energy and natural gas distribution' },
        { value: '137', label: 'Risk management' },
        { value: '135', label: 'Transport and infrastructure (roads, rails, telecommunications, energy etc)' },
        { value: '136', label: 'Workforce changes and demands' },
      ]},
      { value: '39', label: 'Climate resilience', children: [
        { value: '141', label: 'Biodiversity' },
        { value: '139', label: 'Climate adaptation' },
        { value: '140', label: 'Climate monitoring' },
        { value: '142', label: 'Geotextiles' },
      ]},
      { value: '40', label: 'Hybrid civil/defence', children: [
        { value: '143', label: 'Civil crisis preparation' },
        { value: '144', label: 'Emergency management' },
        { value: '214', label: 'Critical communication networks for public security and safety' },
        { value: '215', label: 'Dual-use standards: civil-military mapping and gap analysis' },
      ]},
      { value: '41', label: 'Data protection and cybersecurity', children: [
        { value: '148', label: 'Cyber resilience' },
        { value: '145', label: 'Information security for SMEs' },
        { value: '147', label: 'IT security' },
        { value: '146', label: 'Payment services' },
        { value: '216', label: 'Cybersecurity requirements for products with digital elements' },
        { value: '217', label: 'Machine-readable consent and objection signals' },
        { value: '218', label: 'Customer financial data access and permission dashboards' },
      ]},
    ]
  },
  {
    label: 'Sustainable Digitalisation',
    subGroups: [
      { value: '43', label: 'Data quality and Artificial Intelligence', children: [
        { value: '151', label: 'AI-based decision-making solutions (HR, legislation, labour)' },
        { value: '152', label: 'Circular data' },
        { value: '154', label: 'Data interoperability' },
        { value: '153', label: 'Ethical data usage' },
        { value: '150', label: 'Intelligent factories' },
        { value: '149', label: 'Trustworthy AI' },
        { value: '219', label: 'Resource performance and energy-efficient AI systems' },
        { value: '220', label: 'Data labelling and annotation for AI' },
        { value: '221', label: 'Data capture from connected products, sensors and cameras' },
        { value: '222', label: 'Synthetic data for AI and innovation' },
        { value: '223', label: 'Content authenticity and provenance' },
      ]},
      { value: '44', label: 'Access to and usage of data', children: [
        { value: '160', label: 'Blockchain and digital logbook' },
        { value: '161', label: 'Circular data' },
        { value: '157', label: 'Common European data spaces' },
        { value: '158', label: 'Data interoperability' },
        { value: '159', label: 'Digital twins' },
        { value: '163', label: 'eGovernment' },
        { value: '162', label: 'eID' },
        { value: '155', label: 'Ethical data usage' },
        { value: '156', label: 'Internet of things' },
        { value: '164', label: 'Internet protocols' },
        { value: '224', label: 'Switching and porting between cloud and data processing services' },
        { value: '225', label: 'Public procurement documents and eProcurement interoperability' },
      ]},
      { value: '45', label: 'Space', children: [
        { value: '167', label: '5G from space' },
        { value: '166', label: 'Big data from space' },
        { value: '165', label: 'European Global Navigation Satellite System (EGNSS)' },
      ]},
      { value: '46', label: 'Data and cybersecurity', children: [
        { value: '172', label: 'Audit and certification of information security' },
        { value: '170', label: 'Chips in terms of security, authenticity, reliability' },
        { value: '173', label: 'Cloud Services' },
        { value: '169', label: 'Cyber security in telecommunication' },
        { value: '168', label: 'Cyber- and information security (SME)' },
        { value: '174', label: 'Identity management' },
        { value: '171', label: 'Payment services' },
      ]},
      { value: '47', label: 'Quantum technology', children: [
        { value: '178', label: 'Quantum communication' },
        { value: '175', label: 'Quantum computing' },
        { value: '176', label: 'Quantum sensors' },
        { value: '177', label: 'Quantum simulations' },
        { value: '226', label: 'Post-quantum cryptography protocols' },
      ]},
    ]
  },
  {
    label: 'Green Transition in Europe',
    subGroups: [
      { value: '49', label: 'Clean energy', children: [
        { value: '181', label: 'Clean hydrogen infrastructure' },
        { value: '179', label: 'Clean hydrogen value chain' },
        { value: '182', label: 'Documentation of green fuels' },
        { value: '184', label: 'Energy storage' },
        { value: '183', label: 'Fuelling and refuelling of green fuels' },
        { value: '180', label: 'Gas transportation (incl. hydrogen)' },
        { value: '186', label: 'Smart energy' },
        { value: '185', label: 'Wind turbines' },
        { value: '227', label: 'Small and advanced modular reactors: technology and safety' },
        { value: '228', label: 'Methane emissions in the energy sector' },
      ]},
      { value: '50', label: 'Materials (raw and secondary)', children: [
        { value: '189', label: 'Critical raw materials for batteries and waste batteries' },
        { value: '188', label: 'Plastic recycling incl. textiles' },
        { value: '187', label: 'Recycling of critical raw materials (CRM)' },
        { value: '190', label: 'Recycling/reuse of electrical components (WEEE directive)' },
        { value: '229', label: 'Microplastics and plastic pellet loss measurement' },
      ]},
      { value: '51', label: 'Green and sustainable production', children: [
        { value: '193', label: 'Sustainable product initiative' },
        { value: '195', label: 'Product passport' },
        { value: '194', label: 'Product environmental footprint' },
        { value: '196', label: 'Material passport' },
        { value: '191', label: 'Additive and on-demand manufacturing (3D printing etc.)' },
        { value: '192', label: 'Eco design' },
        { value: '230', label: 'Ecodesign and energy labelling of local space heaters' },
        { value: '231', label: 'Ecodesign and energy labelling of space heaters' },
        { value: '232', label: 'Ecodesign of external power supplies, wireless chargers, battery chargers and USB Type-C cables' },
        { value: '233', label: 'Ecodesign of industrial fans' },
        { value: '234', label: 'Ecodesign and energy labelling of air conditioners and comfort fans' },
        { value: '235', label: 'Ecodesign and energy labelling of water heaters' },
        { value: '236', label: 'Ecodesign for small, medium and large power transformers' },
        { value: '237', label: 'Ecodesign and energy labelling of household tumble dryers' },
        { value: '238', label: 'Compostable packaging' },
        { value: '239', label: 'Sustainable EU algae industry' },
        { value: '240', label: 'Sustainable bio-based products' },
        { value: '241', label: 'Fertilising products from recovered materials and animal by-products' },
      ]},
      { value: '52', label: 'Environmental impact', children: [
        { value: '198', label: 'Carbon capture, utilisation, storage (CCUS)' },
        { value: '197', label: 'Toxic-free environment' },
      ]},
    ]
  },
  {
    label: 'Smart Cities and Circular Economy in Buildings',
    subGroups: [
      { value: '54', label: 'Circular economy in the construction sector', children: [
        { value: '201', label: 'Embedded carbon' },
        { value: '199', label: 'Design for circularity' },
        { value: '200', label: 'Design for disassembly' },
        { value: '205', label: 'Low-carbon cement' },
        { value: '203', label: 'Material and product pass' },
        { value: '204', label: 'Non-destructive testing' },
        { value: '202', label: 'Selective demolition' },
        { value: '242', label: 'Digital building logbooks for construction and building lifecycle data' },
        { value: '243', label: 'Construction products under the new construction products regulation' },
        { value: '244', label: 'Precast concrete products' },
      ]},
      { value: '55', label: 'Transportation', children: [
        { value: '206', label: 'Connected cars' },
        { value: '207', label: 'Green transportation' },
        { value: '245', label: 'Interoperability of the rail system' },
        { value: '246', label: 'Multimodal and multi-operator ticketing services' },
        { value: '247', label: 'Unmanned aircraft systems for low-risk operations' },
      ]},
      { value: '56', label: 'Infrastructure', children: [
        { value: '209', label: 'Postal service' },
        { value: '211', label: 'Critical infrastructure incl. pipes etc.' },
        { value: '210', label: 'Intelligent transportation systems' },
        { value: '208', label: 'Interconnected city' },
      ]},
      { value: '57', label: 'Green buildings', children: [
        { value: '212', label: 'Intelligent buildings' },
        { value: '213', label: 'Indicators for circular buildings' },
      ]},
    ]
  },
  {
    label: 'Single Market and product safety and compliance',
    subGroups: [
      { value: '248', label: 'Product safety', children: [
        { value: '249', label: 'Safety of toys' },
        { value: '250', label: 'Anthropometric considerations for personal protective equipment and machinery' },
        { value: '251', label: 'Lifts and safety components for lifts' },
        { value: '252', label: 'Personal protective equipment' },
        { value: '253', label: 'Low voltage electrical equipment' },
        { value: '254', label: 'Consumer product safety' },
      ]},
      { value: '255', label: 'Compliance and conformity assessment', children: [
        { value: '256', label: 'Radio equipment' },
        { value: '257', label: 'Electromagnetic compatibility' },
        { value: '258', label: 'Pressure equipment, including hydrogen infrastructure and additive manufacturing' },
      ]},
    ]
  },
];
